// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import bicycleIcon from "@/assets/icons/aop/bicycle.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type BicycleIconProps = Omit<IconProps, "name">;

export function BicycleIcon(props: BicycleIconProps): React.ReactNode {
  return <Icon name={bicycleIcon} {...props} />;
}
